<template>
    <span class="text-base font-normal bg-grey-600 text-white px-4 py-1 rounded">
        <slot></slot>
    </span>
</template>